export class ZSuiteHelper {
    static isZSuite(): boolean {
        const zSuiteCookie = document.cookie.match("(^|;)\\s*" + "zsuite" + "\\s*=\\s*([^;]+)");
        const useZSuite = zSuiteCookie ? zSuiteCookie.pop() : "";

        if (useZSuite === "true")
            return true;

        return false || ZSuiteHelper.isClinical();
    }

    static isClinical(): boolean {
        const zSuiteCookie = document.cookie.match("(^|;)\\s*" + "clinicalsuite" + "\\s*=\\s*([^;]+)");
        const useZSuite = zSuiteCookie ? zSuiteCookie.pop() : "";

        if (useZSuite === "true")
            return true;

        return false;
    }
}
